import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
	computed: {
		...mapGetters({
			booking: 'booking/booking',
			isAuth: 'auth/check',
		}),
		stepBydata() {
			let step = 'n/a'
			if (!this.booking.barber) step = 'barber'
			else if (!this.booking.service) step = 'service'
			else if (!this.booking.date) step = 'term'
			else if (!this.booking.time) step = 'term'
			else if (this.booking.time && this.isAuth) step = 'term'
			else if (this.booking.time && !this.isAuth) step = 'personal-data'
			return step
		},
		componentKebab() {
			return this._.kebabCase(this.$options.name)
		},
		componentName() {
			if (this.componentKebab === 'booking') return ''
			return this.$t('booking.steps.' + this.componentKebab)
		},
		currentComponentKebab() {
			return this._.kebabCase(this.booking.step)
		},
		curentComponentName() {
			if (this.currentComponentKebab === 'booking') return ''
			return this.$t('booking.steps.' + this.currentComponentKebab)
		},
		canIIsVisible() {
			let maxKey = parseInt(this._.findKey(this.steps, { component: this.stepBydata }))
			let selfKey = parseInt(this._.findKey(this.steps, { component: this.componentKebab }))

			return selfKey <= maxKey
		},
		isVisible() {
			return this.currentStep && this.loaded
		},
		steps() {
			if (this.isAuth) return this._.omit(this.allSteps, 5)
			return this.allSteps
		},
	},

	data() {
		return {
			allSteps: {
				1: { component: 'barber', name: this.$t('booking.steps.barber') },
				2: { component: 'service', name: this.$t('booking.steps.service') },
				3: { component: 'addons', name: this.$t('booking.steps.addons') },
				4: { component: 'term', name: this.$t('booking.steps.term') },
				5: { component: 'personal-data', name: this.$t('booking.steps.personal-data') },
			},
			loading: false,
			loaded: false,
			currentStep: false,
		}
	},

	async mounted() {
		if (this.booking.step === this.componentKebab) this.currentStep = true

		this.loading = true
		if (this.componentKebab === 'booking') await this.$store.dispatch('booking/start')
		this.setStep(this.stepBydata)
		this.loading = false
	},

	watch: {
		'booking.step'(step) {
			if (step === this.componentKebab) this.currentStep = true
			else this.currentStep = false
		},
		currentStep(currentStep) {
			if (currentStep) {
				this.setStep(this.componentKebab)
				this.show()
			} else {
				Object.assign(this.$data, this.$options.data.call(this))
			}
		},
		// loading(loading) {
		// if (loading) {
		// this.openLoading()
		// }
		// if (!loading) this.closeLoading()
		// },
	},

	methods: {
		...mapMutations({ setBookingId: 'booking/SET_BOOKINGID' }),
		...mapActions({ setStep: 'booking/setStep' }),

		toggleVisibility() {
			let currentStep = !this.currentStep
			if (currentStep && !this.canIIsVisible) return
			this.currentStep = currentStep
		},

		nextStep() {
			let key = parseInt(this._.findKey(this.steps, { component: this.booking.step })) + 1
			let lastKey = parseInt(this._.findLastKey(this.steps))
			let nextStep = key > lastKey ? this.steps[lastKey].component : this.steps[key].component
			this.setStep(nextStep)
		},

		async show() {
			this.loading = true
			this.loaded = false
			if (typeof this.getData === 'function') await this.getData()
			this.loading = false
			this.loaded = true
			this.scrollIntoView()
		},

		scrollIntoView() {
			setTimeout(() => {
				let el = document.getElementById(this.booking.step)
				el.scrollIntoView({ behavior: 'smooth' })
			}, 300)
		},

		async createBooking() {
			if (!this.booking.time) return false
			try {
				let { data } = await this.$http.put(`/bs/${this.booking.id}`)
				this.setBookingId(data)
				this.$router.push({ name: 'booking.summary' })
			} catch ({ response }) {
				this.$notify(response.data.message)
			}
		},
	},
}
